import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {MatCard, MatCardContent} from '@angular/material/card';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';
import {OutlinedButtonComponent} from '@aviary/buttons/outlined-button/outlined-button.component';

@Component({
  selector: 'px-registration-complete',
  host: {
    class: 'flex justify-center px-4'
  },
  templateUrl: './registration-complete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, SelectPipe, FilledButtonComponent, ButtonRouteNameDirective, OutlinedButtonComponent]
})
export class RegistrationCompleteComponent {
  @Input() forLookupContext = false;
  public readonly organizationSelectors = OrganizationSelectors.Auth;
}
